import styles from './date-picker.module.scss';
import { DatePicker as MaterialDatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker as MaterialStaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import nb from "date-fns/locale/nb";
import MaterialCalendarPickerSkeleton from '@mui/lab/CalendarPickerSkeleton';
import TextField from '../text-field/text-field';

/* eslint-disable-next-line */
export interface DatePickerProps {
  onChange: (event: any) => void,
  renderInput?: any,
  // acceptRegex?: any,
  // allowSameDateSelection?: boolean,
  // cancelText?: any,
  // className?: string,
  // clearable?: boolean,
  // clearText?: any,
  // components?: {
  //   LeftArrowButton?: any,
  //   LeftArrowIcon?: any,
  //   OpenPickerIcon?: any,
  //   RightArrowButton?: any,
  //   RightArrowIcon?: any,
  //   SwitchViewButton?: any,
  //   SwitchViewIcon?: any
  // },
  // componentsProps?: {
  //   leftArrowButton?: object,
  //   rightArrowButton?: object,
  //   switchViewButton?: object
  // },
  // defaultCalendarMonth?: any,
  // desktopModeMediaQuery?: string,
  // DialogProps?: object,
  // disableCloseOnSelect?: boolean,
  disabled?: boolean,
  // disableHighlightToday?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  // getOpenDialogAriaText?: any,
  // getViewSwitchingButtonText?: any,
  // InputAdornmentProps?: object,
  inputFormat?: string,
  // inputRef?: any,
  // leftArrowButtonText?: string,
  // loading?: boolean,
  mask?: string,
  // maxDate?: any,
  // minDate?: any,
  // okText?: ReactNode,
  // onAccept?: any,
  // onClose?: any,
  // onError?: any,
  // onMonthChange?: any,
  // onOpen?: any,
  // onViewChange?: any,
  // onYearChange?: any,
  open?: boolean,
  // OpenPickerButtonProps?: object,
  openTo?: 'day' | 'month' | 'year',
  // orientation?: 'landscape' | 'portrait',
  // PaperProps?: object,
  // PopperProps?: object,
  // readOnly?: boolean,
  // reduceAnimations?: boolean,
  // renderDay?: any,
  // renderLoading?: any,
  // rifmFormatter?: any,
  // rightArrowButtonText?: string,
  // shouldDisableDate?: any,
  // shouldDisableYear?: any,
  // showDaysOutsideCurrentMonth?: boolean,
  // showTodayButton?: boolean,
  // showToolbar?: boolean,
  // todayText?: ReactNode,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: any,
  // toolbarTitle?: any,
  // TransitionComponent?: any,
  value?: any | Date | number | string,
  views?: Array<'day' | 'month' | 'year'>,
  label?: any
}

export interface CalendarPickerSkeletonProps {
  // classes?: object,
  sx?: any
}

export interface StaticDatePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  // acceptRegex?: any,
  // allowSameDateSelection?: boolean,
  // className?: string,
  // components?: {
  //   LeftArrowButton?: any,
  //   LeftArrowIcon?: any,
  //   OpenPickerIcon?: any,
  //   RightArrowButton?: any,
  //   RightArrowIcon?: any,
  //   SwitchViewButton?: any,
  //   SwitchViewIcon?: any
  // },
  // componentsProps?: object,
  // defaultCalendarMonth?: any,
  // disableCloseOnSelect?: boolean,
  // disabled?: boolean,
  // disableHighlightToday?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  displayStaticWrapperAs?: 'desktop' | 'mobile',
  // getOpenDialogAriaText?: any,
  // getViewSwitchingButtonText?: any,
  // InputAdornmentProps?: object,
  inputFormat?: string,
  // inputRef?: any,
  // leftArrowButtonText?: string,
  // loading?: boolean,
  mask?: string,
  // maxDate?: any,
  // minDate?: any,
  // onAccept?: any,
  // onClose?: any,
  // onError?: any,
  // onMonthChange?: any,
  // onOpen?: any,
  // onViewChange?: any,
  // onYearChange?: any,
  open?: boolean,
  // OpenPickerButtonProps?: object,
  openTo?: 'day' | 'month' | 'year',
  // orientation?: 'landscape' | 'portrait',
  // readOnly?: boolean,
  // reduceAnimations?: boolean,
  // renderDay?: any,
  // renderLoading?: any,
  // rifmFormatter?: any,
  // rightArrowButtonText?: string,
  // shouldDisableDate?: any,
  // shouldDisableYear?: any,
  // showDaysOutsideCurrentMonth?: boolean,
  // showToolbar?: boolean,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode,
  value?: any | Date | number | string,
  views?: Array<'day' | 'month' | 'year'>,
}

export function DatePicker(props: DatePickerProps) {
  const defaultInput = (params: any) =>
    <TextField
      {...params}
    />
    const inputFormat = props.inputFormat || 'dd.MM.yyyy';
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
      <MaterialDatePicker
        onChange={props.onChange}
        renderInput={props.renderInput || defaultInput}
        value={props.value}
        label={props.label}
        mask={props.mask}
        inputFormat={inputFormat}
        openTo={props.openTo}
        views={props.views}
        disabled={props.disabled}
        open={props.open}
      />
    </LocalizationProvider>
  );
}

export function CalendarPickerSkeleton(props: CalendarPickerSkeletonProps) {
  return (
    <MaterialCalendarPickerSkeleton
      sx={props.sx}
    />
  );
}

export function StaticDatePicker(props: StaticDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
      <MaterialStaticDatePicker
        displayStaticWrapperAs={props.displayStaticWrapperAs}
        openTo={props.openTo}
        value={props.value}
        onChange={props.onChange}
        renderInput={props.renderInput}
        mask={props.mask}
      // open={props.open}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;